import './DownloadSection.css';
import { FaApple, FaAndroid } from 'react-icons/fa';
import phoneMockup from '../assets/phone-mockup-v2.png'; // Bu resmi assets klasörüne ekleyin

const DownloadSection = () => {
  return (
    <section id="download" className="section download-section">
      <div className="container">
        <h2 className="section-title" data-aos="fade-up">
          Hemen <span className="gradient-text">CTO'yu İndirin</span>
        </h2>
        <p className="section-description" data-aos="fade-up" data-aos-delay="100">
          Kripto dünyasındaki fırsatları yakalamak için CTO uygulamasını hemen indirin ve 
          avantajlı özellikleri kullanmaya başlayın.
        </p>
        
        <div className="download-grid">
          <div className="download-image" data-aos="fade-right">
            <img src={phoneMockup} alt="CTO Mobile App" />
          </div>
          
          <div className="download-content" data-aos="fade-left">
            <h3>Tüm Cihazlarda Kullanılabilir</h3>
            <p>
              iOS, Android veya Huawei cihazınızda CTO'yu kullanarak kripto varlıklarınızı 
              istediğiniz yerden yönetin. Mobil uygulamamız sayesinde piyasayı her an 
              takip edin.
            </p>
            
            <div className="download-buttons">
              <a href="https://apps.apple.com/us/app/cto-ai/id6743785600" target='_blank' className="download-button" data-aos="fade-up" rel="noreferrer">
                <FaApple />
                <div>
                  <span>Indirin</span>
                  <strong>App Store</strong>
                </div>
              </a>
              
              <a href="/" className="download-button" data-aos="fade-up" data-aos-delay="100">
                <FaAndroid />
                <div>
                  <span>Indirin</span>
                  <strong>Google Play</strong>
                </div>
              </a>
            </div>
            
            <div className="download-info" data-aos="fade-up" data-aos-delay="300">
              <p>Yakında web uygulaması da hizmetinizde olacak! Aşağıdan e-bülten aboneliğimize katılarak 
              web uygulaması çıktığında ilk haberdar olanlardan olun.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DownloadSection; 